var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "flex gap-2 text-primary" },
        [
          _c("v-icon", { attrs: { color: "primary", size: 20 } }, [
            _vm._v(" mdi-truck-outline "),
          ]),
          _c("span", { staticClass: "text-xl font-medium" }, [
            _vm._v(_vm._s(_vm.$t("shipping.header"))),
          ]),
        ],
        1
      ),
      _c(
        "v-tabs",
        {
          staticClass: "app-tab mt-6",
          attrs: { "show-arrows": "" },
          model: {
            value: _vm.tab,
            callback: function ($$v) {
              _vm.tab = $$v
            },
            expression: "tab",
          },
        },
        _vm._l(_vm.tabHeaders, function (header) {
          return _c(
            "v-tab",
            { key: header.id, attrs: { href: `#${header.value}` } },
            [_vm._v(" " + _vm._s(header.title) + " ")]
          )
        }),
        1
      ),
      _c(
        "v-tabs-items",
        {
          model: {
            value: _vm.tab,
            callback: function ($$v) {
              _vm.tab = $$v
            },
            expression: "tab",
          },
        },
        [
          _c(
            "v-tab-item",
            { attrs: { value: "manage" } },
            [
              _c("shipping-manage", {
                on: {
                  input: function ($event) {
                    return _vm.refetchShippingCalculator()
                  },
                  submit: function ($event) {
                    return _vm.refetchShippingCalculator()
                  },
                },
              }),
            ],
            1
          ),
          _vm.permission.settingShippingCalculator
            ? _c(
                "v-tab-item",
                { attrs: { value: "calculate" } },
                [
                  _c(
                    "v-card",
                    { attrs: { flat: "" } },
                    [
                      _c(
                        "v-card-text",
                        [
                          _c("calculate-data-table", {
                            ref: "CaculateDataTable",
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.permission.settingShippingCalculator
            ? _c(
                "v-tab-item",
                { attrs: { value: "manage-cod" } },
                [
                  _c(
                    "v-card",
                    { attrs: { flat: "" } },
                    [_c("v-card-text", [_c("cod-form")], 1)],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }